(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/pix-wager.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/pix-wager.js');
(function(Backbone, _, svs) {
  'use strict';


  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.PixWager = Backbone.Model.extend({
    defaults: function() {
      return {
        wager: {
          crc: 0,
          marketInfo: 0,
          bagType: 0,
          bets: [
            {
              productId: 'MATCHEN', 
              drawNum: 0, 
              numDraws: 1, 
              betAmountSalesGroup1: '0,00', 
              betAmountSalesGroup2: '0,00',
              rowPriceMulti: 0,
              betProperties: [
                'XPERTEN'
              ],
              expertenBoardData: {
                eventResults: [
                  [
                    [], 
                    [] 
                  ]
                ]
              }
            }
          ]
        }
      };
    }
  });
})(Backbone, _, svs);


 })(window);